// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hYgf","label":"styles_label__2TTwb"};